export default __webpack_public_path__ + "static/invitationImg-3d51150659df11b9268f75cf875c4ba6.png";